const isDevelopment = window.location.hostname === 'localhost' ||
                     window.location.hostname === '127.0.0.1' ||
                     window.location.hostname.includes('localhost');

const isProduction = window.location.hostname === 'loopra.com.br' ||
                    window.location.hostname.endsWith('loopra.com.br');

// Debug logging for environment detection
console.log('[CONFIG] Hostname:', window.location.hostname);
console.log('[CONFIG] Is Development:', isDevelopment);
console.log('[CONFIG] Is Production:', isProduction);




export const config = {
  apiUrl: isDevelopment
    ? (process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL !== '' ? process.env.REACT_APP_API_URL : 'http://localhost:8081')
    : (process.env.REACT_APP_PRODUCTION_API_URL && process.env.REACT_APP_PRODUCTION_API_URL !== '' ? process.env.REACT_APP_PRODUCTION_API_URL : 'https://loopra.com.br'),

  wsUrl: isDevelopment
    ? (process.env.REACT_APP_WS_URL || 'ws://localhost:8081/ws/updates')
    : (process.env.REACT_APP_PRODUCTION_WS_URL || 'wss://loopra.com.br/ws/updates'),

  facebookRedirectUri: isDevelopment
    ? (process.env.REACT_APP_FACEBOOK_REDIRECT_URI || 'http://localhost:3000/settings-callback')
    : (process.env.REACT_APP_PRODUCTION_FACEBOOK_REDIRECT_URI || 'https://loopra.com.br/settings-callback'),

  isDevelopment,
  isProduction,
  environment: isDevelopment ? 'development' : 'production'
};

export default config;